import { render } from "./DesktopSelectedTransaction.vue?vue&type=template&id=a2c32884&scoped=true&ts=true"
import script from "./DesktopSelectedTransaction.vue?vue&type=script&lang=ts"
export * from "./DesktopSelectedTransaction.vue?vue&type=script&lang=ts"

import "./DesktopSelectedTransaction.vue?vue&type=style&index=0&id=a2c32884&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c32884"]])

export default __exports__